<!-- 卡密管理 -->
<template>
    <div class="ck-config-container">
        <div class="ck-config-data-box"> 
            <el-card class="mb16" shadow="never">   
                <div class="flexX flexcenter flexBetween">
                    <div>CK配置</div>
                    <el-button type="primary" @click="openaddCKConfig"  size="small">添加ck配置</el-button>
                </div>          
                
            </el-card>
            <div v-for="(item,index) in ckConfigData.ck_list" :key="index">
                <CKConfigItem :ckConfig="item" @openCKConfig="openCKConfig" @deleteCKConfig="deleteCK"></CKConfigItem>
            </div>
           
        </div>   
        <div class="dialog-box">
            <!-- 编辑ck配置 -->
            <EditCKConfig :title="dialogData.title" v-if="dialogData.visible" :dialogVisible = "dialogData.visible" :form = "dialogData.item" :loading = "dialogData.loading" @close="closeEditCKConfig" @sure="sureEditCKConfig"></EditCKConfig>
        </div>    
    </div>

   
</template>
<script>
	import {Message} from 'element-ui'
    import EditCKConfig from '@/components/CKConfig/editCKConfig.vue'
    import  CKConfigItem from '@/components/CKConfig/ckConfigItem.vue'
    export default {
        name: 'CKConfig',
        components:{EditCKConfig,CKConfigItem},
        data() {
            return{
                ckConfigData:{
                    config:{
                        ck_value:'',
                        ck_status:0,
                        ck_valid:1,
                        ck_valid_text:'是'
                    },
                    ck_list:[],
                    loading:false,
                },
                dialogData:{
                    title:'编辑CK配置',
                    visible:false,
                    loading:false,
                    item:{}
                }
            }
          
        },
        created() {
           this.getCkConfig()
        },
       
        methods: {
            getCkConfig(){
                this.ckConfigData.loading = true;
                this.$api.getCkConfig({}).then(res=>{
                    this.ckConfigData.loading = false
                    if(res.status == 1){
                        this.ckConfigData.ck_list = res.data.ck_list
                    }else{
                        this.$message.error(res.msg)
                    }
                }).catch(e=>{
                    this.ckConfigData.loading = false
                })

            },
            openCKConfig(config){
                this.dialogData.item = config;
                this.dialogData.visible = true;
                this.dialogData.title = '编辑CK配置'
            },
            openaddCKConfig(){
                this.dialogData.item = {
                    ck_value:'',
                    ck_status:1,
                    ck_name:''
                };
                this.dialogData.title = '添加CK配置'
                this.dialogData.visible = true;
            },
            closeEditCKConfig(){
                this.dialogData.visible = false;
            },
            sureEditCKConfig(param){
                // console.log(param,'编辑CKConfig参数')
                // this.closeEditCKConfig();

                if(param.id){
                    // 编辑 
                    this.updateCkConfig(param)
                }else{
                    //添加
                    this.addCkConfig(param)
                }
               
            },
            //添加ck配置 接口
            addCkConfig(param){
                this.dialogData.loading = true
                this.$api.saveCkConfig(param).then(res=>{
                    this.dialogData.loading = false
                    if(res.status == 1){
                        this.$message.success(res.msg)
                        this.closeEditCKConfig()
                        this.getCkConfig()
                    }else{
                        this.$message.error(res.msg)
                    }
                }).catch(e=>{
                    this.dialogData.loading = false;
                })

            },
            //编辑ck配置 接口
            updateCkConfig(param){
                let data={
                    ck_id:param.id,
                    ...param
                }
                this.dialogData.loading = true                
                this.$api.updateCkConfig(data).then(res=>{
                    this.dialogData.loading = false
                    if(res.status == 1){
                        this.$message.success(res.msg)
                        this.closeEditCKConfig()
                        this.getCkConfig()
                    }else{
                        this.$message.error(res.msg)
                    }
                }).catch(e=>{
                    this.dialogData.loading = false;
                })
            },
            //删除ck配置
            deleteCK(param){
                this.$confirm('确认删除此数据吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log(param,'删除参数')
                    if(param.id){
                        this.deleteCkConfig(param.id)
                    }else{
                        this.ckConfigData.ck_list.splice(this.ckConfigData.ck_list.length - 1 ,1)
                    }
                }).catch((e) => {
                    console.log(e)
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            // 删除ck配置接口
            deleteCkConfig(id){
                this.ckConfigData.loading = true
                this.$api.deleteCkConfig({ck_id:id}).then(res=>{
                this.ckConfigData.loading = false
                if(res.status == 1){
                    this.$message.success(res.msg)
                    this.getCkConfig()
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(e=>{
                this.ckConfigData.loading = false
            })
            }
       
        },
        watch: {
           
        }
    }
</script>
<style lang="scss">
    @import "@/style/tablestyle.scss";
	// @import '@/style/variables.scss';
</style>
<style lang="scss" scoped>
//内层弹窗input框样式
   .ck-config-container{
    .ck-config-data-box{
        // background: #fff;
        .header-content{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
       
    }
   }
</style>